import React, { useState, useContext } from 'react'
import StateContext from '../StateContext'
import DispatchContext from '../DispatchContext'
import { useTheme } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';

import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button';
import Axios from 'axios'
import AuthTabs from './AuthenticationTabs'

// get Cookie function
import { setCookie } from '../Functions/cookieFunction';
import { handleError } from '../Functions/getAlert';

const useStyles = makeStyles((theme) => ({
     root: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
     },
     wrapper: {
          marginTop: '1.5rem',
          position: 'relative',
     },
     buttonSuccess: {
          backgroundColor: green[500],
          '&:hover': {
               backgroundColor: green[700],
          },
     },
     fabProgress: {
          color: green[500],
          position: 'absolute',
          top: -6,
          left: -6,
          zIndex: 1,
     },
     buttonProgress: {
          color: green[500],
          position: 'absolute',
          top: '50%',
          left: '50%',
          marginTop: -12,
          marginLeft: -12,
     },
}));

const LoginMd = (props) => {

     const appState = useContext(StateContext)

     const [isLoading, setIsLoading] = useState(true)
     const theme = useTheme();
     const [fullWidth] = useState(true);
     const [maxWidth, setMaxWidth] = useState('sm')
     const [loading, setLoading] = useState(false)
     const [email, setEmail] = useState('')
     const [password, setPassword] = useState('')
     const appDispatch = useContext(DispatchContext)
     const classes = useStyles();
    

     const handleSubmit = async e => {
          e.preventDefault();

          if (email && password !== '') {
               setLoading(true)
               try {
                    const response = await Axios.post(`${process.env.REACT_APP_API_URL}login/customer-login`, { email: email, password: password })
                    if (response.data.data.email === email) {
                         setLoading(false)
                         // setSuccess(true)
                         appDispatch({ type: "login", login: response.data.data.id, token: response.data.accessToken })
                         setCookie('tokenAuth', response.data.accessToken, 1)
                         props.setAlertMessage({ open: true, message: "Logged In Successfully", alertSuccess: true })
                         window.location.reload()

                    }
               } catch (e) {
                    setLoading(false)
                    handleError(e, appDispatch)
               }
          }
          else {
               setLoading(false)
               alert('fill')
               // setAlertMessage({ open: true, message: 'Please fill these fields!', alertSuccess: false })
          }
     }

     return (
          <React.Fragment>
               <form action="" onSubmit={handleSubmit}>
                    <div className="form-group w-100 " >
                         <TextField label="Email" value={email} onChange={e => setEmail(e.target.value)} className="field-control w-100" type="email" />
                    </div>
                    <div className="form-group">
                         <TextField label="Password" value={password} onChange={e => setPassword(e.target.value)} className="field-control w-100" type="password" />
                    </div>
                    <div className="form-group text-center">
                         <div className={classes.root}>
                              {/* classes.wrapper */}
                              <div className={classes.wrapper}>
                                   <Button variant="contained" className={`bg-primary login_btn`} disabled={loading} type="submit">
                                        {loading ? 'Redirecting' : 'Login'}
                                   </Button>
                                   {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                              </div>
                         </div>
                    </div>
               </form>
          </React.Fragment>
     );
}
export default LoginMd
